import { render, staticRenderFns } from "./lltlocallaw.vue?vue&type=template&id=f59314a6&scoped=true&"
import script from "./lltlocallaw.vue?vue&type=script&lang=js&"
export * from "./lltlocallaw.vue?vue&type=script&lang=js&"
import style0 from "./lltlocallaw.vue?vue&type=style&index=0&id=f59314a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59314a6",
  null
  
)

export default component.exports